import { default as Input } from 'antd/es/input';
import type { InputProps } from 'antd/es/input';
import cn from 'classnames';
import type { Dispatch } from 'react';

import { formatIBAN } from 'utils/formatters/ibanFormatter';

import { useAntMask } from 'hooks/useAntMask';

type Props = {
  onChange?: Dispatch<string>;
  value?: string;
} & Omit<InputProps, 'onChange' | 'value'>;

/**
 * Custom IBAN input formatting for readability
 */
export const IBANInput = ({ className, onChange, value, ...props }: Props) => {
  const { mask } = useAntMask({
    validator: new RegExp(String.raw`^[a-zA-Z0-9\s]+$`, 'g'),
    replacer: /\s/g,
    separator: ' ',
    formatter: formatIBAN,
    value,
    onChange
  });

  return (
    <Input {...mask} className={cn('h-10 w-full', className)} {...props} />
  );
};
